import { useEffect } from 'react';

import { getActiveStation } from '../../store/selectors/getActiveStation';
import { getContextCollectionName } from '../../store/selectors/getContextCollectionName';
import { getHeaderText } from '../../store/selectors/getHeaderText';
import { getProjectLayoutModel } from '../../store/selectors/getProjectLayoutModel';
import { useAppSelector } from '../hooks';

export function BrowserTabTitle() {
  const context = useAppSelector((state) => state.application.openContext);
  const project = useAppSelector(getProjectLayoutModel);
  const sharedComponentSet = useAppSelector((state) => state.sharedComponentSet.sharedComponentSet);
  const activeStation = useAppSelector(getActiveStation);
  const contextName = useAppSelector(getContextCollectionName);
  const titleEnd = useAppSelector(getHeaderText);

  const titleStart = (() => {
    switch (context?.type) {
      case 'project':
        return project?.name;

      case 'shared-component-set':
        return sharedComponentSet?.name;

      case 'station':
      case 'schedule-station':
        return activeStation?.name;

      default:
        return contextName;
    }
  })();

  const title = titleStart && titleEnd ? `${titleStart} - ${titleEnd}` : (titleStart ?? titleEnd ?? 'Paragon');

  useEffect(() => void (document.title = title), [title]);

  return null;
}
